var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext, useEffect, useRef } from "react";
import { Col, Row, InputGroup } from "react-bootstrap";
import { Button, Form, Pill, Well, SubmitButton, FadeSection, Icon, DotsLoader, HorizontalRule, Error, } from "@brushfire/ui";
import { getCartId, getLocal, LOCAL_STORAGE_KEYS, removeLocal, setLocal, } from "../../../../../data/localStorageHelpers";
import { postOrder, postOrderFree, postPromoCode, removePromoCode, updateCart } from "../../../../../data/api";
import { setCartData } from "../../../../../store/Cart/actions";
import { clearInlineErrors, setFormIsSubmitting, setInlineError } from "../../../../../store/AppState/actions";
import { useDispatch, useSelector } from "react-redux";
import { getDefaultCountry, handleErrors, handleSubmittedOrder } from "../../../../../data/helpers";
import WidgetFieldset from "../../../../Helpers/WidgetFieldset";
import useWidgetHistory from "../../../../../hooks/useWidgetHistory";
import { useIntl } from "react-intl";
import * as Yup from "yup";
import FormikContextListener from "../../../../Helpers/FormikContextListener";
import Constants from "../../../../../data/constants";
import { WidgetContext } from "../../../../Widget";
import { isEqual } from "lodash";
import { AppFormContext } from "../../../../../App";
import useWidgetAnalytics from "../../../../../hooks/useWidgetAnalytics";
import { phone } from "phone";
import { clearSubmittedForms } from "../../../../../store/Record/actions";
import FormikValuesListener from "../../../../Helpers/FormikValuesListener";
import { isPossiblePhoneNumber } from "react-phone-number-input/input";
import CartExpiredModal from "./CartExpiredModal";
import { integrationsEventOrderPlaced } from "../../../../../store/Integrations/actions";
import SquareWalletButton from "../../../../PaymentProcessors/Square/SquareWalletButton";
import { setWalletConfirmationPayload, } from "../../../../PaymentProcessors/PaymentForm";
import { useSpecificBFPayment } from "../../../../../hooks/useSpecificBFPayment";
import ReCAPTCHA from "react-google-recaptcha";
import Number from "../../../../UI/Number";
var useTypedSelector = useSelector;
var getCountryCodeSafe = function (sourceCountry) {
    if (sourceCountry) {
        if (sourceCountry.length === 2) {
            return sourceCountry;
        }
        else if (sourceCountry.toLowerCase() === "united states") {
            return "US";
        }
    }
    return undefined;
};
var CartSummary = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var cart = _a.cart, currency = _a.currency, eventData = _a.eventData, path = _a.path, continueOverride = _a.continueOverride, showSummary = _a.showSummary, isMobile = _a.isMobile, widgetPaymentRequest = _a.widgetPaymentRequest, returnToSummary = _a.returnToSummary;
    var _q = __read(React.useState(false), 2), setIsSavingPromo = _q[1];
    var _r = __read(React.useState(false), 2), showPrefilledMessage = _r[0], setShowPrefilledMessage = _r[1];
    var _s = __read(React.useState(), 2), initialValues = _s[0], setInitialValues = _s[1];
    var _t = __read(React.useState(), 2), removingPromo = _t[0], setRemovingPromo = _t[1];
    var _u = __read(React.useState(), 2), promoValues = _u[0], setPromoValues = _u[1];
    var _v = __read(React.useState(false), 2), submitPromo = _v[0], setSubmitPromo = _v[1];
    var _w = __read(React.useState(false), 2), isCartExpired = _w[0], setIsCartExpired = _w[1];
    var _x = __read(React.useState(null), 2), squarePayments = _x[0], setSquarePayments = _x[1];
    var kiosk = useTypedSelector(function (store) { return store.utilities; }).kiosk;
    var _y = useTypedSelector(function (store) { return store.accounts; }), customerAccount = _y.customerAccount, account = _y.account;
    var _z = useTypedSelector(function (store) { return store.utilities; }), localization = _z.localization, dotNetConstants = _z.constants;
    var formIsSubmitting = useTypedSelector(function (store) { return store.app; }).formIsSubmitting;
    var dispatch = useDispatch();
    var history = useWidgetHistory();
    var analytics = useWidgetAnalytics();
    var _0 = useContext(WidgetContext), externalAccount = _0.externalAccount, isPortal = _0.isPortal;
    var formikContext = useContext(AppFormContext).formikContext;
    // invisible recaptcha only if:
    // - free order
    // - not signed in to portal account
    var recaptchaRef = useRef(null);
    var showCaptcha = !(customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.id) && process.env.REACT_APP_BF_ENV !== "staging" && process.env.REACT_APP_BF_ENV !== "future";
    var _1 = useSpecificBFPayment(widgetPaymentRequest.paymentMethods), bfPaymentAllowsWalletOrAfterpay = _1.bfPaymentAllowsWalletOrAfterpay, bfPaymentAllowsCheckout = _1.bfPaymentAllowsCheckout, removeSpecificBFPayment = _1.removeSpecificBFPayment;
    var showSquareButtons = bfPaymentAllowsWalletOrAfterpay &&
        (((_c = (_b = widgetPaymentRequest.paymentProfile) === null || _b === void 0 ? void 0 : _b.config) === null || _c === void 0 ? void 0 : _c.allowAfterpay) ||
            ((_e = (_d = widgetPaymentRequest.paymentProfile) === null || _d === void 0 ? void 0 : _d.config) === null || _e === void 0 ? void 0 : _e.allowWallets));
    var showCheckoutButton = bfPaymentAllowsCheckout;
    var paymentProfile = cart.paymentProfile;
    var intl = useIntl();
    var freeCheckout = cart.total === 0;
    var getPrefilledValues = function (setShowPrefilled) {
        var _a, _b, _c, _d, _e, _f;
        if (setShowPrefilled === void 0) { setShowPrefilled = true; }
        if (freeCheckout) {
            if (externalAccount) {
                if (setShowPrefilled) {
                    setShowPrefilledMessage(true);
                }
                if (externalAccount.phone) {
                    var res = phone(externalAccount.phone, { validateMobilePrefix: false });
                    if (res.isValid) {
                        externalAccount.phone = res.phoneNumber;
                    }
                }
                return __assign(__assign({}, externalAccount), { shippingId: (_a = cart.shippingId) !== null && _a !== void 0 ? _a : undefined, country: getCountryCodeSafe(externalAccount.country) ||
                        getCountryCodeSafe(eventData === null || eventData === void 0 ? void 0 : eventData.clientCountry) ||
                        "US", password: "", confirmPassword: "", recaptchaResponse: "" });
            }
            else if (cart.checkoutInfo) {
                if (setShowPrefilled) {
                    setShowPrefilledMessage(true);
                }
                if (cart.checkoutInfo.phone) {
                    var res = phone(cart.checkoutInfo.phone, { validateMobilePrefix: false });
                    if (res.isValid) {
                        cart.checkoutInfo.phone = res.phoneNumber;
                    }
                }
                return __assign(__assign({}, cart.checkoutInfo), { shippingId: (_b = cart.shippingId) !== null && _b !== void 0 ? _b : undefined, country: getCountryCodeSafe(cart.checkoutInfo.country) ||
                        getCountryCodeSafe(eventData === null || eventData === void 0 ? void 0 : eventData.clientCountry) ||
                        "US", password: "", confirmPassword: "", recaptchaResponse: "" });
            }
            return {
                shippingId: (_c = cart.shippingId) !== null && _c !== void 0 ? _c : undefined,
                country: (_d = getCountryCodeSafe(eventData === null || eventData === void 0 ? void 0 : eventData.clientCountry)) !== null && _d !== void 0 ? _d : "US",
                password: "",
                confirmPassword: "",
                recaptchaResponse: "",
            };
        }
        else {
            return {
                shippingId: (_e = cart.shippingId) !== null && _e !== void 0 ? _e : undefined,
                country: (_f = getCountryCodeSafe(eventData === null || eventData === void 0 ? void 0 : eventData.clientCountry)) !== null && _f !== void 0 ? _f : "US",
                password: "",
                confirmPassword: "",
            };
        }
    };
    var placeWalletOrder = function (values, payload, formikBag, setGlobalError, handleAction) {
        if (handleAction === void 0) { handleAction = true; }
        if (cart && eventData) {
            var payloadToPost = __assign(__assign({}, payload), { cartId: cart.cartId });
            formikBag.setSubmitting(true);
            dispatch(clearInlineErrors());
            dispatch(setFormIsSubmitting(true));
            postOrder(payloadToPost)
                .then(function (_a) {
                var data = _a.data;
                formikBag.setSubmitting(false);
                if (data.requiresAction && handleAction) {
                }
                else {
                    formikBag.resetForm({ values: values });
                    dispatch(setFormIsSubmitting(false));
                    dispatch(clearSubmittedForms(eventData.eventNumber.toString()));
                    if (cart) {
                        analytics.purchase(data.result.orderKey, eventData, cart);
                    }
                    handleSubmittedOrder(data.result, eventData, history);
                    dispatch(setCartData(undefined));
                    removeSpecificBFPayment();
                }
            })
                .catch(function (err) {
                var _a, _b, _c, _d, _e;
                dispatch(setInlineError({
                    checkoutWalletForm: (_d = (_c = (_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.errors) === null || _b === void 0 ? void 0 : _b.map(function (err) { return err.value; })) === null || _c === void 0 ? void 0 : _c.join("")) !== null && _d !== void 0 ? _d : (_e = err.response) === null || _e === void 0 ? void 0 : _e.data.message,
                }));
                handleErrors(err, dispatch, formikBag, setGlobalError);
                formikBag.setSubmitting(false);
                dispatch(setFormIsSubmitting(false));
            });
        }
    };
    useEffect(function () {
        var values = getPrefilledValues();
        setInitialValues(values);
    }, []);
    var tryToMountSquare = function (applicationId, locationId, times) {
        if (window === null || window === void 0 ? void 0 : window.Square) {
            if (!squarePayments) {
                setSquarePayments(window.Square.payments(applicationId, locationId));
            }
        }
        else {
            if (times < 10) {
                setTimeout(function () {
                    tryToMountSquare(applicationId, locationId, times + 1);
                }, 1000);
            }
            else {
                dispatch(setInlineError({
                    paymentGatewayOutage: "Payments appear to be unavailable right now. The payment provider is not responding. Please try again later.",
                }));
            }
        }
    };
    useEffect(function () {
        var _a, _b;
        var applicationId = (paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.gatewayId) === Constants.Gateways.GATEWAY_SQUARE
            ? dotNetConstants === null || dotNetConstants === void 0 ? void 0 : dotNetConstants.squareApplicationId
            : dotNetConstants === null || dotNetConstants === void 0 ? void 0 : dotNetConstants.squareSandboxApplicationId;
        var locationId = (_b = (_a = paymentProfile === null || paymentProfile === void 0 ? void 0 : paymentProfile.config) === null || _a === void 0 ? void 0 : _a.locationId) !== null && _b !== void 0 ? _b : "";
        if (applicationId && locationId) {
            tryToMountSquare(applicationId, locationId, 0);
        }
    }, [dotNetConstants, paymentProfile]);
    useEffect(function () {
        if (path === Constants.Routes.cart && eventData && cart && freeCheckout) {
            analytics.startCheckout(eventData, cart);
        }
    }, [path, freeCheckout]);
    useEffect(function () {
        var _a, _b;
        if (path === Constants.Routes.cart && !isEqual(getPrefilledValues(false), initialValues)) {
            if (formikContext && ((_b = (_a = formikContext.status) === null || _a === void 0 ? void 0 : _a.bag) === null || _b === void 0 ? void 0 : _b.isCart)) {
                var newValues = getPrefilledValues();
                setInitialValues(newValues);
                formikContext.resetForm({ values: newValues });
            }
        }
    }, [externalAccount, cart.checkoutInfo, path, (_f = formikContext === null || formikContext === void 0 ? void 0 : formikContext.status) === null || _f === void 0 ? void 0 : _f.bag]);
    var formSchema = freeCheckout
        ? Yup.object().shape({
            firstName: Yup.string()
                .typeError("First Name is required")
                .required("First Name is required")
                .max(50, "First Name must be 50 or fewer characters"),
            lastName: Yup.string()
                .typeError("Last Name is required")
                .required("Last Name is required")
                .max(50, "Last Name must be 50 or fewer characters"),
            email: Yup.string()
                .typeError("Email is required")
                .email("Email is invalid")
                .required("Email is required")
                .max(100, "Email must be 100 or fewer characters"),
            phone: Yup.string()
                .nullable()
                .max(20, "Phone is too long")
                .test("valid", "Phone number is invalid", function (val) { return (val ? isPossiblePhoneNumber(val) : true); }),
            street1: Yup.string()
                .nullable()
                .max(100, "Address must be 100 or fewer characters"),
            street2: Yup.string()
                .nullable()
                .nullable()
                .max(100, "Address 2 must be 100 or fewer characters"),
            region: Yup.string()
                .nullable()
                .max(100, "Region must be 100 or fewer characters"),
            city: Yup.string()
                .nullable()
                .max(100, "City must be 100 or fewer characters"),
            country: Yup.string()
                .nullable()
                .max(2, "Country must be 2 or fewer characters"),
            postalCode: Yup.string()
                .nullable()
                .max(10, "Postal Code must be 10 or fewer characters"),
            password: Yup.string()
                .nullable()
                .test("len", "Password must be at least 8 characters", function (val) {
                return val === null ||
                    val === undefined ||
                    (val === null || val === void 0 ? void 0 : val.length) === 0 ||
                    ((val === null || val === void 0 ? void 0 : val.length) >= 8 && (val === null || val === void 0 ? void 0 : val.length) <= 500);
            }),
            confirmPassword: Yup.string()
                .nullable()
                .oneOf([Yup.ref("password")], "Passwords Must Match"),
        })
        : ((_h = (_g = cart === null || cart === void 0 ? void 0 : cart.deliveryMethods) === null || _g === void 0 ? void 0 : _g.length) !== null && _h !== void 0 ? _h : 0) > 1
            ? Yup.object().shape({
                shippingId: Yup.string().required("Delivery Method is required"),
            })
            : undefined;
    var row = function (title, amount, isTotal, isDiscount) {
        if (isTotal === void 0) { isTotal = false; }
        if (isDiscount === void 0) { isDiscount = false; }
        var HeadingTag = isTotal ? "h4" : "h6";
        return (_jsxs(Row, __assign({ className: "".concat(isTotal ? "m-top p-top b-top b-dashed" : "m-top-sm") }, { children: [_jsx(Col, __assign({ xs: 8 }, { children: _jsx(HeadingTag, __assign({ className: "".concat(isTotal ? "bold" : "").concat(isDiscount ? " success" : "") }, { children: title })) })), _jsx(Col, __assign({ xs: 4, className: "ta-right" }, { children: _jsx(HeadingTag, __assign({ className: "".concat(isTotal ? "bold" : "").concat(isDiscount ? " success" : "") }, { children: _jsx(Number, { value: amount !== null && amount !== void 0 ? amount : 0, style: "currency", currency: currency }) })) }))] })));
    };
    var addPromo = function (values, formikBag, setGlobalError) {
        var _a;
        if (values.promo) {
            setIsSavingPromo(true);
            dispatch(setFormIsSubmitting(true));
            postPromoCode(getCartId(cart.eventNumber), values.promo, (_a = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber.toString()) !== null && _a !== void 0 ? _a : "")
                .then(function (_a) {
                var data = _a.data;
                formikBag.setValues({ promo: "" });
                dispatch(setCartData(data));
            })
                .catch(function (err) {
                handleErrors(err, dispatch, formikBag, setGlobalError);
            })
                .finally(function () {
                setIsSavingPromo(false);
                dispatch(setFormIsSubmitting(false));
                formikBag.setSubmitting(false);
            });
        }
    };
    var removePromo = function (id, formikContext, setGlobalError) {
        var _a;
        setRemovingPromo(id);
        removePromoCode(getCartId(cart.eventNumber), id, (_a = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber.toString()) !== null && _a !== void 0 ? _a : "")
            .then(function (_a) {
            var data = _a.data;
            var removedPromo = cart.promotions.find(function (promo) { return promo.id === id; });
            dispatch(setCartData(data));
            removeLocal(LOCAL_STORAGE_KEYS.PROMO);
            // also add to removed promo codes
            if (removedPromo && removedPromo.autoCalculate) {
                var existing = getLocal(LOCAL_STORAGE_KEYS.REMOVED_PROMOS);
                setLocal(LOCAL_STORAGE_KEYS.REMOVED_PROMOS, "".concat(existing, "|").concat(removedPromo.id), 5 * 60);
            }
        })
            .catch(function (err) {
            var _a, _b;
            if (!!((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message)) {
                handleErrors(err, dispatch, formikContext, setGlobalError);
            }
        })
            .finally(function () {
            setRemovingPromo(undefined);
        });
    };
    var submitFreeOrder = function (values, formikBag, setGlobalError) { return __awaiter(void 0, void 0, void 0, function () {
        var token, _a, payload, url;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    if (!showCaptcha) return [3 /*break*/, 4];
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    formikBag.setSubmitting(false);
                    return [4 /*yield*/, ((_b = recaptchaRef === null || recaptchaRef === void 0 ? void 0 : recaptchaRef.current) === null || _b === void 0 ? void 0 : _b.executeAsync())];
                case 2:
                    token = _e.sent();
                    values.recaptchaResponse = token !== null && token !== void 0 ? token : "";
                    formikBag.setSubmitting(true);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _e.sent();
                    formikBag.setSubmitting(false);
                    (_c = recaptchaRef === null || recaptchaRef === void 0 ? void 0 : recaptchaRef.current) === null || _c === void 0 ? void 0 : _c.reset();
                    formikBag.setFieldError("recaptchaResponse", "Recaptcha is required.");
                    return [2 /*return*/];
                case 4:
                    if (continueOverride) {
                        continueOverride();
                        formikBag.setSubmitting(false);
                    }
                    else if (freeCheckout && eventData) {
                        payload = __assign(__assign({}, values), { cartId: cart.cartId, thirdPartyCustomerId: (_d = externalAccount === null || externalAccount === void 0 ? void 0 : externalAccount.thirdPartyCustomerId) !== null && _d !== void 0 ? _d : "" });
                        delete payload.shippingId;
                        if (values.phone === "") {
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            //@ts-ignore
                            payload.phone = null;
                        }
                        postOrderFree(payload)
                            .then(function (_a) {
                            var data = _a.data;
                            if (data.requiresAction) {
                                setGlobalError("Something went wrong while placing your order.");
                            }
                            else if (!data) {
                                // cart validation failed b/c cart was cleared and null was returned
                                setIsCartExpired(true);
                                formikBag.setSubmitting(false);
                                formikBag.resetForm({ values: values });
                            }
                            else {
                                formikBag.setSubmitting(false);
                                formikBag.resetForm({ values: values });
                                dispatch(integrationsEventOrderPlaced(data));
                                dispatch(clearSubmittedForms(eventData.eventNumber.toString()));
                                analytics.purchase(data.result.orderKey, eventData, cart);
                                dispatch(setCartData(undefined));
                                handleSubmittedOrder(data.result, eventData, history);
                                removeSpecificBFPayment();
                            }
                        })
                            .catch(function (err) {
                            handleErrors(err, dispatch, formikContext, setGlobalError);
                            formikBag.setSubmitting(false);
                        });
                    }
                    else {
                        if ((promoValues === null || promoValues === void 0 ? void 0 : promoValues.promo) && !cart.promotions.some(function (promo) { return promo.names.includes(promoValues.promo); })) {
                            setSubmitPromo(true);
                            formikBag.setSubmitting(false);
                        }
                        else {
                            formikBag.setSubmitting(false);
                            formikBag.resetForm({ values: values });
                            if (eventData) {
                                url = Constants.Routes.checkout
                                    .replace(":clientKey", eventData.clientKey)
                                    .replace(":urlKey", eventData.urlKey)
                                    .replace(":eventNumber", eventData.eventNumber.toString());
                                history.push(url, undefined, false);
                            }
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var updateDeliveryMethod = function (shippingId, setGlobalError) {
        var _a;
        dispatch(setFormIsSubmitting(true));
        updateCart(cart.cartId, { shippingId: shippingId }, (_a = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber.toString()) !== null && _a !== void 0 ? _a : "")
            .then(function (_a) {
            var data = _a.data;
            dispatch(setCartData(data));
        })
            .catch(function (_a) {
            var _b, _c;
            var err = _a.err;
            if (!!((_c = (_b = err === null || err === void 0 ? void 0 : err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message)) {
                handleErrors(err, dispatch, formikContext, setGlobalError);
            }
        })
            .finally(function () {
            dispatch(setFormIsSubmitting(false));
        });
    };
    var setWalletConfirmationPayloadLocal = function (walletConfirmationPayload) {
        var _a;
        if (formikContext && eventData) {
            setWalletConfirmationPayload(walletConfirmationPayload, placeWalletOrder, formikContext, eventData, localization, (_a = externalAccount === null || externalAccount === void 0 ? void 0 : externalAccount.thirdPartyCustomerId) !== null && _a !== void 0 ? _a : "");
        }
    };
    var continueClick = function () {
        if (formikContext) {
            formikContext.submitForm();
        }
    };
    if (!((_j = cart.attendees) === null || _j === void 0 ? void 0 : _j.length) || !initialValues) {
        return null;
    }
    return (_jsxs("div", { children: [!freeCheckout && (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "cart-summary-detail m-top" }, { children: [row(_jsxs(_Fragment, { children: ["".concat(cart.attendeeCount > 0
                                    ? "".concat(cart.attendeeCount, " Attendee").concat(cart.attendeeCount !== 1 ? "s" : "")
                                    : "").concat(cart.addonCount > 0
                                    ? "".concat(cart.attendeeCount > 0 ? ", " : "").concat(cart.addonCount, " Add-on").concat(cart.addonCount === 1 ? "" : "s")
                                    : ""), isMobile && (_jsx("small", { children: _jsxs("a", __assign({ href: "#", onClick: function (evt) {
                                            evt.preventDefault();
                                            evt.stopPropagation();
                                            if (returnToSummary) {
                                                returnToSummary();
                                            }
                                        } }, { children: [" ", "(Edit)"] })) }))] }), cart.attendeeTotal), !!cart.discountTotal && _jsx(_Fragment, { children: row("Discounts", cart.discountTotal, false, true) }), !!cart.taxTotal && _jsx(_Fragment, { children: row((_k = eventData === null || eventData === void 0 ? void 0 : eventData.taxLabel) !== null && _k !== void 0 ? _k : "Taxes", cart.taxTotal) }), !!cart.feeTotal && (cart.feeTotal ? _jsx(_Fragment, { children: row("Service Fees", cart.feeTotal) }) : null), !!cart.deliveryTotal && _jsx(_Fragment, { children: row("Delivery", cart.deliveryTotal) }), _jsx(_Fragment, { children: row("Order Total", cart.total, true) }), !freeCheckout &&
                            path === Constants.Routes.cart &&
                            ((_m = (_l = widgetPaymentRequest.paymentProfile) === null || _l === void 0 ? void 0 : _l.config) === null || _m === void 0 ? void 0 : _m.allowAfterpay) && (_jsxs(Row, __assign({ style: { marginTop: -15 } }, { children: [_jsx(Col, { xs: 6 }), _jsx(Col, __assign({ xs: 6, className: "ta-right", style: { minHeight: 15 } }, { children: _jsx("afterpay-placement", { "data-amount": cart.total, "data-badge-theme": "black-on-mint", "data-currency": (_o = widgetPaymentRequest === null || widgetPaymentRequest === void 0 ? void 0 : widgetPaymentRequest.currency) !== null && _o !== void 0 ? _o : "USD", "data-locale": (_p = eventData === null || eventData === void 0 ? void 0 : eventData.culture) !== null && _p !== void 0 ? _p : "en_US", "data-modal-link-style": "none", "data-modal-theme": "undefined", "data-size": "xs" }) }))] })))] })) })), cart.showPromos && (!freeCheckout || cart.promotions.length > 0) && (_jsx(FadeSection, __assign({ fade: path === Constants.Routes.cart }, { children: _jsx(Form, __assign({ initialValues: {}, onSubmit: addPromo, useUnsavedPrompt: false }, { children: function (_a) {
                        var formikContext = _a.formikContext, setGlobalError = _a.setGlobalError;
                        return (_jsxs("div", __assign({ className: "promo-form-wrap m-top-medium" }, { children: [_jsx(FormikValuesListener, { values: promoValues, setValues: setPromoValues, submit: submitPromo, setSubmit: setSubmitPromo }), _jsx(WidgetFieldset, { children: _jsxs(InputGroup, __assign({ className: "promo-form" }, { children: [_jsx(Form.Field, { label: "Promo Code", placeholder: "Enter Code", id: "promo", name: "promo", isFieldRequired: true, autoComplete: (kiosk === null || kiosk === void 0 ? void 0 : kiosk.enabled) ? "new-off" : undefined }), _jsx(InputGroup.Append, { children: _jsx("div", __assign({ style: { marginTop: 19.5 } }, { children: _jsx(SubmitButton, __assign({ component: Button, type: "submit", classes: "btn-sm m-0", purpose: "secondary", disabled: !formikContext.values.promo }, { children: _jsx(Icon, { icon: "check" }) })) })) })] })) }), cart.promotions.map(function (promo) { return (_jsx("span", __assign({ "data-promo": promo.names[0] }, { children: _jsx(Pill, { purpose: "light", text: promo.names[0], onRemoveClick: function () {
                                            removePromo(promo.id, formikContext, setGlobalError);
                                        }, busy: promo.id === removingPromo, className: "round" }) }), promo.id)); })] })));
                    } })) }))), _jsx(Form, __assign({ initialValues: initialValues, onSubmit: submitFreeOrder, validationSchema: continueOverride ? undefined : formSchema, formikBagProps: {
                    submitButtonLabel: freeCheckout && showSummary ? "Submit" : showSummary ? "Checkout" : "Continue",
                    isCart: true,
                    isMobile: isMobile,
                    hideFooter: !freeCheckout && !!squarePayments && showSummary,
                }, autoComplete: (kiosk === null || kiosk === void 0 ? void 0 : kiosk.enabled) ? "new-off" : undefined, useUnsavedPrompt: false }, { children: function (_a) {
                    var _b, _c, _d, _e;
                    var formikContext = _a.formikContext;
                    var resetForm = function () {
                        var _a;
                        setShowPrefilledMessage(false);
                        formikContext.resetForm({ values: { shippingId: (_a = cart === null || cart === void 0 ? void 0 : cart.shippingId) !== null && _a !== void 0 ? _a : null } });
                    };
                    return (_jsxs(WidgetFieldset, { children: [_jsx(FormikContextListener, { currentPath: path, path: "".concat(Constants.Routes.cart), formikContext: formikContext, initialValues: initialValues, active: true }), freeCheckout && (_jsxs(_Fragment, { children: [_jsx(Form.Input.NameInput, { labelClear: showPrefilledMessage, resetForm: resetForm, isRequired: true, isColumn: false }), _jsx(Form.Field, { label: "Email", id: "email", name: "email", type: "email", autoComplete: (kiosk === null || kiosk === void 0 ? void 0 : kiosk.enabled) ? "new-off" : undefined, placeholder: "name@domain.com" }), _jsx(Form.Field, { component: Form.Input.Phone, label: "Phone", id: "phone", name: "phone", autoComplete: !(kiosk === null || kiosk === void 0 ? void 0 : kiosk.enabled), defaultCountry: getDefaultCountry(eventData) }), showCaptcha && (_jsxs(_Fragment, { children: [_jsx(ReCAPTCHA, { ref: recaptchaRef, sitekey: Constants.RecaptchaSiteKey, onChange: function (value) {
                                                    formikContext.setFieldValue("recaptchaResponse", value);
                                                }, size: "invisible" }), ((_b = formikContext.errors) === null || _b === void 0 ? void 0 : _b.recaptchaResponse) &&
                                                formikContext.submitCount > 0 && (_jsx(Error, { children: (_c = formikContext.errors) === null || _c === void 0 ? void 0 : _c.recaptchaResponse }))] })), !(kiosk === null || kiosk === void 0 ? void 0 : kiosk.enabled) &&
                                        isPortal &&
                                        (customerAccount === null || customerAccount === void 0 ? void 0 : customerAccount.email) === undefined &&
                                        (account === null || account === void 0 ? void 0 : account.email) === undefined && (_jsxs("div", __assign({ className: "field" }, { children: [_jsxs("label", __assign({ htmlFor: "password" }, { children: ["Create a password and we'll remember your info for next time! It's fast, easy, and secure! ", _jsx("span", __assign({ className: "optional" }, { children: "- Optional" }))] })), _jsxs(Row, { children: [_jsx(Col, __assign({ xs: 12, md: 6 }, { children: _jsx(Form.Field, { label: "Password", hiddenLabel: true, id: "password", name: "password", type: "password", autoComplete: "new-password", placeholder: "Password", fieldClassName: "" }) })), _jsx(Col, __assign({ xs: 12, md: 6 }, { children: _jsx(Form.Field, { label: "Confirm Password", hiddenLabel: true, id: "confirmPassword", name: "confirmPassword", type: "password", autoComplete: "new-password", placeholder: "Re-type Password", fieldClassName: "" }) }))] })] })))] })), _jsx(FadeSection, __assign({ fade: path === Constants.Routes.cart }, { children: _jsx("div", __assign({ className: "shipping-form-wrap" }, { children: cart.deliveryMethods.length > 1 ? (_jsx("div", __assign({ className: "shipping-form m-bottom" }, { children: _jsx(Form.Field, { component: Form.Input.Select, className: "field tall-select", label: "Delivery Method", hiddenLabel: true, placeholder: "Delivery Method", id: "shippingId", name: "shippingId", isFieldRequired: true, data: cart.deliveryMethods.map(function (d) { return ({
                                                value: d.shippingId,
                                                label: (_jsxs(_Fragment, { children: [_jsx("div", { children: "".concat(d.method, " ").concat(d.fee > 0
                                                                ? "+ ".concat(intl.formatNumber(d.fee, {
                                                                    style: "currency",
                                                                    currency: eventData === null || eventData === void 0 ? void 0 : eventData.currency,
                                                                }))
                                                                : "", "\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t") }), _jsx("small", { children: d.description })] })),
                                            }); }), onChange: function (opt) {
                                                updateDeliveryMethod(opt.value, formikContext.status.setGlobalError);
                                            } }) }))) : (_jsxs(Well, __assign({ className: "lg well-flat well-outline well-sidebar m-0 m-bottom-well" }, { children: [_jsxs("p", __assign({ className: "m-bottom-sm" }, { children: [_jsx("b", { children: cart.deliveryMethods[0].method }), cart.deliveryMethods[0].fee > 0
                                                        ? "+ ".concat(intl.formatNumber(cart.deliveryMethods[0].fee, {
                                                            style: "currency",
                                                            currency: eventData === null || eventData === void 0 ? void 0 : eventData.currency,
                                                        }))
                                                        : ""] })), _jsx("small", { children: (_d = cart.deliveryMethods[0]) === null || _d === void 0 ? void 0 : _d.description })] }))) })) })), !freeCheckout && !!squarePayments && showSummary && path === Constants.Routes.cart && (_jsxs(_Fragment, { children: [showSquareButtons && (_jsx(SquareWalletButton, { payments: squarePayments, widgetPaymentRequest: widgetPaymentRequest, setWalletConfirmationPayload: setWalletConfirmationPayloadLocal, formikContext: formikContext, setErrorMessage: function (error) {
                                            dispatch(setInlineError({ checkoutForm: error }));
                                        }, loading: formIsSubmitting !== null && formIsSubmitting !== void 0 ? formIsSubmitting : false, eventNumber: (_e = eventData === null || eventData === void 0 ? void 0 : eventData.eventNumber.toString()) !== null && _e !== void 0 ? _e : "" })), showSquareButtons && showCheckoutButton && (_jsx(HorizontalRule, __assign({ className: "smaller" }, { children: "OR" }))), showCheckoutButton && (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ purpose: "primary", type: "submit", classes: "btn-block m-top-sm", onClick: continueClick, customBusyIcon: _jsx(DotsLoader, { classes: "dots-button btn-spinner white" }), busy: formikContext === null || formikContext === void 0 ? void 0 : formikContext.isSubmitting }, { children: _jsx("span", __assign({ className: "semi-bold" }, { children: "Checkout" })) })), _jsx("div", __assign({ className: "m-bottom-well m-top-sm" }, { children: _jsxs("small", { children: ["By continuing, you accept our", " ", _jsx("a", __assign({ href: "https://get.brushfire.help/hc/en-us/articles/360011675720-Terms-of-Use", target: "_blank", rel: "noopener noreferrer" }, { children: "terms of service" })), " ", "and", " ", _jsx("a", __assign({ href: "https://get.brushfire.help/hc/en-us/articles/360011675740-Privacy-Policy", target: "_blank", rel: "noopener noreferrer" }, { children: "privacy policy" })), " ", "and agree that Brushfire may share your information with the event organizer."] }) }))] }))] })), (freeCheckout || path === Constants.Routes.checkout) && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "checkout-disclaimer m-bottom-well ".concat(path === Constants.Routes.checkout ? "m-top" : "") }, { children: _jsxs("small", { children: ["By continuing, you accept our", " ", _jsx("a", __assign({ href: "https://get.brushfire.help/hc/en-us/articles/360011675720-Terms-of-Use", target: "_blank", rel: "noopener noreferrer" }, { children: "terms of service" })), " ", "and", " ", _jsx("a", __assign({ href: "https://get.brushfire.help/hc/en-us/articles/360011675740-Privacy-Policy", target: "_blank", rel: "noopener noreferrer" }, { children: "privacy policy" })), " ", "and agree that Brushfire may share your information with the event organizer."] }) })), showCaptcha && (_jsxs("p", __assign({ className: "mini" }, { children: ["This site is protected by reCAPTCHA and the Google", " ", _jsx("a", __assign({ href: "https://policies.google.com/privacy" }, { children: "Privacy Policy" })), " and", " ", _jsx("a", __assign({ href: "https://policies.google.com/terms" }, { children: "Terms of Service" })), " apply."] })))] })), _jsx(CartExpiredModal, { show: isCartExpired, setShow: setIsCartExpired })] }));
                } }))] }));
};
export default CartSummary;
